module.exports = __webpack_public_path__ + "static/media/Thumbs.d2e70af7.db";